import { Graphics } from "pixi.js";
import { CommonData } from "../../datastructures/gamestate/gameData";

enum orientation {
  portrait = "portrait",
  landscape = "landscape",
}
export class MinimumStakeDisplayPopup extends PIXI.Container {
  private minStake: number = 0;
  private currentStake: number = 0;
  private messageText: PIXI.Text;
  private betPlaced: boolean = false;
  private commonData: CommonData;
  private bg: Graphics;
  private messageContainer: PIXI.Container = new PIXI.Container();
  private portraitPositionY: number = 0;
  private landScapePositionY: number = 0;
  private currentMode: string = orientation.landscape;
  private isInitilized: boolean = false;
  public disableForGamesWithId: number[] = []; //ad here list of game id to disable the popup
  private selectedMarketOnlyFilter: string[] = ["nl"];
  private currentGameId: number = 0;
  constructor(data: CommonData) {
    super();
    this.commonData = data;
    this.messageContainer.visible = false;
    this.currentGameId = this.commonData.gameId;

    this.createBackground();
    this.createMessageText();

    this.setVisible(false);

    this.filterBasedOnGameId();
    this.filterBasedOnMarket(); //only add the message container if the game is in the market filter
  }

  private filterBasedOnMarket() {
    if (this.selectedMarketOnlyFilter.includes(this.commonData.gameMarketID)) {
      this.addChild(this.messageContainer);
      this.isInitilized = true;
    }
  }

  private filterBasedOnGameId() {
    // Check if the current game ID is in the list of disabled game IDs  SO for  Roulette and American Roulette
    if (this.disableForGamesWithId.includes(this.currentGameId)) {
      this.onFirstSpin();
    }
  }

  private createMessageText() {
    this.messageText = new PIXI.Text("", {
      fontSize: 80,
      fill: 0xffffff,
      wordWrap: true,
      wordWrapWidth: 800,
      stroke: 0x000000,
      strokeThickness: 8,
      align: "center",
    });
    this.messageText.anchor.set(0.5);
    this.messageText.position.set(0, 0);
    this.messageContainer.addChild(this.messageText);
  }

  private setVisible(bool: boolean) {
    bool;
    if (this.betPlaced === false) {
      if (this.currentStake <= this.minStake) {
        this.hide();
      } else {
        this.show();
      }
    } else {
      this.hide();
    }
  }
  private createBackground() {
    let bg_Size_X = 1000;
    let bg_Size_Y = 70;
    this.bg = new PIXI.Graphics();
    this.bg.beginFill(0x000000, 0.5); // Set the fill color and alpha
    this.bg.drawRoundedRect(
      -bg_Size_X / 2,
      -bg_Size_Y / 2,
      bg_Size_X,
      bg_Size_Y,
      12
    ); // Draw a rectangle covering the entire canvas
    this.bg.endFill();
    this.messageContainer.addChild(this.bg);
  }

  private updateMessageText() {
    if (this.commonData.gameTextGeneral.MINIMUM_STAKE_POPUP === undefined) {
      return;
    }
    let textTemplate = this.commonData.gameTextGeneral.MINIMUM_STAKE_POPUP;
    textTemplate = textTemplate.replace(
      "{mStake}",
      this.minStake.toFixed(2) + this.commonData.currency
    );
    textTemplate = textTemplate.replace(
      "{cStake}",
      this.currentStake.toFixed(2) + this.commonData.currency
    );
    this.onBetChange();
    this.messageText.text = textTemplate;
  }

  public setMinStake(minStake: number) {
    if (this.isInitilized === false) {
      return;
    }
    this.minStake = minStake;
    this.updateMessageText();
  }

  public setCurrentStake(currentStake: number) {
    if (this.isInitilized === false) {
      return;
    }
    this.currentStake = currentStake;
    this.updateMessageText();
  }

  private onBetChange() {
    if (this.betPlaced === false) {
      if (this.currentStake <= this.minStake) {
        this.hide();
      } else {
        this.show();
      }
    } else {
      this.hide();
    }
  }

  public onFirstSpin() {
    if (this.betPlaced === false) {
      {
        this.betPlaced = true;
        this.updateMessageText();
      }
    }
  }

  private hide() {
    this.visible = false;
  }

  private show() {
    this.visible = true;
  }

  public setPortraitPositionY(positionY: number) {
    this.portraitPositionY = positionY;

    if (this.currentMode === orientation.portrait) {
      //update the position of the message container
      this.setPortraitMode();
    }
  }

  public setLandScapePositionY(positionY: number) {
    this.landScapePositionY = positionY;

    if (this.currentMode === orientation.landscape) {
      //update the position of the message container
      this.setLandScapeMode();
    }
  }

  private setMessageContainerVisible() {
    //make it visible after setting the position
    if (!this.messageContainer.visible) {
      this.messageContainer.visible = true;
    }
  }
  public setLandScapeMode() {
    this.messageText.style.fontSize = 25;
    this.messageText.style.wordWrapWidth = this.commonData.size[0] / 2;
    this.bg.width = this.commonData.size[0] / 2 - 50;
    this.bg.height = this.messageText.height + 20;
    this.currentMode = orientation.landscape;
    this.messageContainer.y = this.landScapePositionY;

    this.setMessageContainerVisible();
  }
  public setPortraitMode() {
    this.messageText.style.fontSize = 40;
    this.messageText.style.wordWrapWidth = this.commonData.size[0] - 220;
    this.bg.width = this.commonData.size[0] - 200;
    this.bg.height = this.messageText.height + 20;
    this.currentMode = orientation.portrait;

    this.messageContainer.y = this.portraitPositionY;
    this.setMessageContainerVisible();
  }
}
